<template>
  <div
    class="news"
    v-if="this.language == 'eng'"
    style="font-family: 'Times New Roman', Times, serif"
  >
    <Pic-top></Pic-top>
    <div class="exhibitionTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">Home</span>
          <span>&nbsp;>&nbsp;</span>
          <span class="color">News Updates</span>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <div class="newsContent">
      <div class="section">
        <div
          class="item wow animate__animated animate__fadeInDown"
          v-for="(item, index) in list"
          :key="index"
          @click="goDetail(item)"
        >
          <div class="left">
            <img v-if="item.image" :src="url + item.image.fileUrl" alt="" />
            <img v-else src="../../assets/news/newsLogo.png" alt="" />
          </div>
          <div class="right">
            <div class="title eng_title">
              {{ item.englishTitle }}
            </div>
            <div class="right_time">
              {{ item.publishTime?item.publishTime:item.createTime.slice(0,11) }}
            </div>
            <div class="content">
              {{ item.englishProfile }}
            </div>
          </div>
        </div>
      </div>
      <div
        class="loading"
        v-loading="loading"
        element-loading-text="数据加载中"
        element-loading-spinner="el-icon-loading"
      ></div>
    </div>
  </div>
  <div class="news" v-else-if="this.language == 'en'">
    <Pic-top></Pic-top>
    <div class="exhibitionTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)"> ངོ་བྱང་།</span>
          <span>&nbsp;>&nbsp;</span>
          <span class="color"> གསར་འགྱུར་གྱི་གནས་ཚུལ།</span>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <div class="newsContent">
      <div class="section">
        <div
          class="item wow animate__animated animate__fadeInDown"
          v-for="(item, index) in list"
          :key="index"
          @click="goDetail(item)"
        >
          <div class="left">
            <img v-if="item.image" :src="url + item.image.fileUrl" alt="" />
            <img v-else src="../../assets/news/newsLogo.png" alt="" />
          </div>
          <div class="right">
            <div class="title">
              {{ item.zangTitle }}
            </div>
            <div class="right_time">
              {{ item.publishTime?item.publishTime:item.createTime.slice(0,11) }}
            </div>
            <div class="content">
              {{ item.zangProfile }}
            </div>
          </div>
        </div>
      </div>
      <div
        class="loading"
        v-loading="loading"
        element-loading-text="གཞི་གྲངས་སྣོན་འཇུག་ཁྲོད་"
        element-loading-spinner="el-icon-loading"
      ></div>
    </div>
  </div>
  <div class="news" v-else>
    <Pic-top></Pic-top>
    <div class="exhibitionTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">首页</span>
          <span>&nbsp;>&nbsp;</span>
          <span class="color">新闻动态</span>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <div class="newsContent">
      <div class="section">
        <div
          class="item wow animate__animated animate__fadeInDown"
          v-for="(item, index) in list"
          :key="index"
          @click="goDetail(item)"
        >
          <div class="left">
            <img v-if="item.image" :src="url + item.image.fileUrl" alt="" />
            <img v-else src="../../assets/news/newsLogo.png" alt="" />
          </div>
          <div class="right">
            <div class="title">
              {{ item.chineseTitle }}
            </div>
            <div class="right_time">
              {{ item.publishTime?item.publishTime:item.createTime.slice(0,11) }}
            </div>
            <div class="content">
              {{ item.chineseProfile }}
            </div>
          </div>
        </div>
      </div>
      <div
        class="loading"
        v-loading="loading"
        element-loading-text="数据加载中"
        element-loading-spinner="el-icon-loading"
      ></div>
    </div>
  </div>
</template>
<script>
import { noticePage } from "../../api/management";
import PicTop from "../../components/picsTop.vue";
import { throttle } from 'lodash'
export default {
  components: {
    PicTop,
  },
  data() {
    return {
      language: this.$store.state.language,
      list: [],
      url: process.env.VUE_APP_WEB_URL,
      total: null,
      queryInfo: {
        current: 1,
        pageSize: 8,
        title: "",
      },
      loading: false,
      isLoading:false
    };
  },
  computed: {
    changeLanguage() {
      return this.$store.state.language;
    },
  },
  watch: {
    changeLanguage: function (val) {
      this.language = val;
    },
  },
  mounted() {
    new this.$wow.WOW().init();
  },
  created() {
    this.getPCorMobile();
  },
  methods: {
    // pc
    async getNewsList() {
      this.loading = true;
      const res = await noticePage(this.queryInfo);
      if(res.code==1) {
        this.loading = false
        this.isLoading = false
        this.list = this.list.concat(res.data.records);
        this.total = res.data.total;
      }
    },
    getPCorMobile() {
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        this.getNewsList();
        window.addEventListener("scroll", this.Scrollbottom, true);
      } else {
        this.getNewsList();
        window.addEventListener("scroll", this.PCscrollbottom, true);
      }
    },
    PCscrollbottom:throttle(function(event)  {
      // 变量scrollTop为当前页面的滚动条纵坐标位置
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 变量 windowHeight 是可视区的高度
      let windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      // 变量 scrollHeight 是滚动条的总高度
      let scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      // 到底的条件
      if (scrollTop + windowHeight == scrollHeight) {
          if(this.isLoading) {
            if (this.queryInfo.current * 8 >= this.total) {
              this.isLoading = false
              return this.$message("数据加载完毕");
            }
            this.loading = true;
            this.queryInfo.current++;
            this.getNewsList();
          }
      } else {
        this.isLoading = true
      }
    },1000),
    Scrollbottom:throttle(function(event) {
      // 变量scrollTop为当前页面的滚动条纵坐标位置
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 变量 windowHeight 是可视区的高度
      let windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      // 变量 scrollHeight 是滚动条的总高度
      let scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      // 到底的条件
      if (scrollTop + windowHeight + 100 >= scrollHeight) {
          if(this.isLoading) {
            if (this.queryInfo.current * 8 >= this.total) {
              this.isLoading = false
              return this.$message("数据加载完毕");
            }
            this.loading = true;
            this.queryInfo.current++;
            this.getNewsList();
          }
      } else {
        this.isLoading = true
      }
    },2000),
    goDetail(item) {
      if (item.link) {
        window.open(item.link);
      } else {
        this.$router.push({ path: "/newsDetail", query: { id: item.id } });
      }
    },
    handleRouter(num) {
      this.$store.commit("changeNum", num);
      this.$router.push("/index");
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.PCscrollbottom, true);
    window.removeEventListener("scroll", this.Scrollbottom, true);
  },
};
</script>
<style lang="scss">
.news {
  background: url("../../assets/newImage/index/could_right.png") no-repeat right
    bottom;
  background-position: 100% 100%;
  position: relative;
  background-size: 7%;
  .exhibitionTop {
    position: relative;
    border-bottom: 1px solid #f4f5f6;
    .section {
      padding: 50px 0;
      font-size: 18px;
      position: relative;
      .section_left {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        z-index: 88;
        .color {
          color: #ed201a;
        }
        span {
          cursor: pointer;
        }
      }
    }
    .cloudLeft {
      position: absolute;
      top: 50px;
      left: 0;
      z-index: 1;
      width: 125px;
      height: 95px;
    }
  }
  .newsContent {
    margin: 50px 0 60px 0;
    .section {
      .item {
        margin-bottom: 40px;
        display: flex;
        align-items: center;
        cursor: pointer;
        .left {
          img {
            width: 300px;
            height: 170px;
            border: 1px solid #cacdd1;
          }
        }
        .right {
          margin-left: 40px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          .title,
          .content {
            overflow: hidden !important;
            overflow-wrap: break-word !important;
            text-overflow: ellipsis !important;
            -webkit-box-orient: vertical !important;
            display: -webkit-box !important;
          }
          .title {
            font-size: 19px;
            font-weight: 600;
            // font-family: "fangzang";
            margin-bottom: 15px;
            -webkit-line-clamp: 1 !important;
          }
          .right_time {
            font-size: 15px;
            color: #b7b7b7;
            margin-bottom: 15px;
          }
          .eng_title {
            font-family: "Times New Roman", Times, serif;
          }
          .content {
            font-size: 16px;
            line-height: 25px;
            color: #656565;
            -webkit-line-clamp: 4 !important;
          }
        }
      }
    }
    .loading {
      margin-bottom: 20px;
      .el-loading-mask {
        .el-loading-spinner {
          .el-icon-loading {
            color: #ef3731;
          }
          .el-loading-text {
            color: #ef3731;
          }
        }
      }
    }
  }
}
@media (max-width: 768px) {
  .news {
    background: url("../../assets/newImage/index/could_right.png") no-repeat
      right bottom;
    background-size: 1rem;
    position: relative;
    padding-bottom: 0.3rem;
    .exhibitionTop {
      position: relative;
      .section {
        background: url("../../assets/newImage/index/could_left.png") no-repeat
          top left;
        background-position: 0 50%;
        background-size: 15%;
        padding: 0.6rem 0.2rem;
        font-size: 0.3rem;
        .section_left {
          left: 0.2rem;
        }
      }
      .cloudRight {
        position: absolute;
        top: 6%;
        right: 0;
        width: 1.25rem;
      }
    }
    .newsContent {
      margin: 0.5rem 0 0.6rem 0;
      .section {
        .item {
          margin-bottom: 0.5rem;
          .left {
            img {
              height: 2.3rem;
              width: 3rem;
            }
          }
          .right {
            margin-left: 0.2rem;
            padding:  0.1rem;
            .title,
            .content {
              overflow: hidden !important;
              overflow-wrap: break-word !important;
              text-overflow: ellipsis !important;
              display: -webkit-box !important;
              -webkit-box-orient: vertical !important;
            }
            .title {
              font-size: 0.32rem;
              margin-bottom: 0.15rem;
              line-height: 0.4rem;
              -webkit-line-clamp: 1 !important;
            }
            .right_time {
              font-size: 0.28rem;
              margin-bottom: 0.15rem;
            }
            .content {
              font-size: 0.28rem;
              line-height: 0.45rem;
              -webkit-line-clamp: 2 !important;
            }
          }
        }
      }
    }
    .mobilecloudLeft {
      position: absolute;
      bottom: -3.5%;
      right: 0;
      width: 1.25rem;
    }
  }
}
</style>
